import { getGoldCoinName, getSweepsCoinName } from "./complianceCopy";
import { isDTS } from "./platform";

const DREAM_CASH_BUCKETS = new Set(["dc_general", "dc_freebet", "dc_sticky"]);

export const getWagerUnitName = (fundingBucket) =>
  DREAM_CASH_BUCKETS.has(fundingBucket)
    ? getSweepsCoinName()
    : getGoldCoinName();

/** DTS coins are named units and must never be presented as US dollars. */
export const formatWagerAmount = (formattedAmount, fundingBucket) =>
  isDTS()
    ? `${formattedAmount} ${getWagerUnitName(fundingBucket)}`
    : `$ ${formattedAmount}`;
